import { useCallback } from "react";

import { losPipelineApi } from "../../api/losPipelineApi";
import { dealsForTab } from "../../constants/pipelineTabs";
import PipelineTableScreen from "./PipelineTableScreen";

// Post Close tab. Per loan_and_auth_endpoints.md §3–§4 there is NO per-stage
// endpoint — this is a client-side slice of the shared
// /loportal/user_pipeline payload, filtered to the "Post Close"
// bucket (pipeline "Closed" / loanStatus "Closed"; incl. post-close conditions).
const PostClosePipelineScreen = () => {
  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losPipelineApi
      .getUserPipeline()
      .then((deals) => onSuccessFn?.(dealsForTab(deals, "POST_CLOSE")))
      .catch(onError);
  }, []);

  return (
    <PipelineTableScreen
      title="Post Close"
      storageKeyPrefix="post-close-pipeline"
      fetchData={fetchData}
    />
  );
};

export default PostClosePipelineScreen;
